import React from 'react';
import appConfig from '../config/appConfig';

const styles = {
  wrapper: {
    backgroundColor: '#f9fafb',
    minHeight: '100vh',
    padding: '40px 20px',
  },
  container: {
    maxWidth: '780px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.04)',
    padding: '48px 56px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    color: '#1a1a1a',
    lineHeight: 1.7,
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    marginBottom: '4px',
    color: '#111827',
  },
  subtitle: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '36px',
    borderBottom: '1px solid #e5e7eb',
    paddingBottom: '20px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
    marginTop: '32px',
    marginBottom: '12px',
  },
  paragraph: {
    fontSize: '15px',
    color: '#374151',
    marginBottom: '16px',
  },
  list: {
    fontSize: '15px',
    color: '#374151',
    paddingLeft: '24px',
    marginBottom: '16px',
  },
  listItem: {
    marginBottom: '8px',
  },
  link: {
    color: '#2563eb',
    textDecoration: 'none',
    fontWeight: 500,
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #e5e7eb',
    margin: '32px 0',
  },
};

export default function TermsPage() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.title}>Terms of Service</h1>
        <p style={styles.subtitle}>
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
        </p>

        <h3 style={styles.sectionTitle}>1. Overview</h3>
        <p style={styles.paragraph}>
          Timeline is a social app for creating plans, inviting people, posting memories,
          and building shared timelines. By accessing or using Timeline, you agree to these Terms
          of Service and our Privacy Policy.
        </p>
        <p style={styles.paragraph}>
          You must be at least <strong>18 years old</strong> to use Timeline. If we discover that a user
          is under 18, the account may be terminated.
        </p>

        <h3 style={styles.sectionTitle}>2. Account &amp; Eligibility</h3>
        <p style={styles.paragraph}>
          Accounts are created using Google Sign-In. You agree to provide accurate information and
          maintain only one account. You are responsible for safeguarding your login credentials.
          We may suspend or terminate accounts that violate these terms or applicable laws.
        </p>

        <h3 style={styles.sectionTitle}>3. Acceptable Use</h3>
        <ul style={styles.list}>
          <li style={styles.listItem}>Be respectful and act in good faith toward other users.</li>
          <li style={styles.listItem}>Harassment, bullying, hate speech, threats, or impersonation are strictly prohibited.</li>
          <li style={styles.listItem}>Do not share illegal, obscene, defamatory, or infringing content.</li>
          <li style={styles.listItem}>Do not use bots, scraping tools, or attempt to bypass app safeguards.</li>
          <li style={styles.listItem}>Do not misuse deep links or attempt to access other users' data without permission.</li>
        </ul>

        <h3 style={styles.sectionTitle}>4. User Content</h3>
        <p style={styles.paragraph}>
          You retain ownership of the content you upload, such as photos, bios, and plans.
          By using Timeline, you grant us a non-exclusive, royalty-free licence to store, display,
          and process this content solely to operate and improve the service.
        </p>

        <h3 style={styles.sectionTitle}>5. Plans &amp; discovery</h3>
        <p style={styles.paragraph}>
          Timeline lets you create public, private, or invite-only plans, invite people, and browse a global feed of plans.
          Visibility preferences are controlled within the app.
        </p>

        <h3 style={styles.sectionTitle}>6. Premium Features</h3>
        <p style={styles.paragraph}>
          Certain features may be available through paid subscriptions. Payments and refunds are
          managed through the app stores and subject to their policies.
        </p>

        <hr style={styles.divider} />

        <h3 style={styles.sectionTitle}>7. Disclaimers</h3>
        <p style={styles.paragraph}>
          Timeline is provided "as is" without warranties of any kind. We do not guarantee connections
          or uninterrupted service. Interactions with other users are at your own risk.
        </p>

        <h3 style={styles.sectionTitle}>8. Limitation of Liability</h3>
        <p style={styles.paragraph}>
          To the maximum extent permitted by law, Timeline shall not be liable for indirect,
          incidental, or consequential damages. Our total liability will not exceed the amount
          you paid us in the last twelve months, if any.
        </p>

        <h3 style={styles.sectionTitle}>9. Termination</h3>
        <p style={styles.paragraph}>
          You may delete your account at any time by requesting us. We may suspend or terminate accounts that violate
          these terms, engage in misuse, or for legal or operational reasons.
        </p>

        <h3 style={styles.sectionTitle}>10. Governing Law</h3>
        <p style={styles.paragraph}>
          These terms are governed by the laws of India. Any disputes shall be subject to the
          jurisdiction of Indian courts.
        </p>

        <hr style={styles.divider} />

        <h3 style={styles.sectionTitle}>11. Contact</h3>
        <p style={styles.paragraph}>
          For questions, support, or legal inquiries, reach out at{' '}
          <a href={`mailto:${appConfig.supportEmail}`} style={styles.link}>
            {appConfig.supportEmail}
          </a>.
        </p>
      </div>
    </div>
  );
}
